
import React, { useState, useEffect } from "react";
import ObjectForm from "../../Common/ObjectForm";
import http from "../../Common/RestAPIHandler";

const DeviceCredentialForm = props => {
  const [formFields, setFormFields] = useState();
	const [categories, setCategories] = useState([]);  

	useEffect(() => {
		http.Get(
			`categories?tenant=${props.companyTenant?props.companyTenant.id:null}&category_type=Credential Type`,
			(data) => {
				var valueMap = {};
				for (let i = 0; i < data.length; i++) {
					valueMap[data[i].id] = data[i].category_name;
				}
				setCategories(valueMap);
			},
			() => {}
		);
  }, []);

  useEffect(() => {
    if(categories){
      setFormFields([
        { 
          id: "category", 
          label: "CREDENTIAL TYPE", 
          type: "select",
          valueMap: categories
        },
        { 
          id: "description", 
          label: "DESCRIPTION", 
          type: "text", 
        },
        { 
          id: "username", 
          label: "USERNAME *", 
          type: "text", 
        },
        { 
          id: "password", 
          label: "PASSWORD *", 
          type: "password", 
        },
      ]);

    }

  }, [categories]);


  return(
    <div>{formFields && <ObjectForm {...props} url={`device_credentials`} formName={"Device Credential"} formFields={formFields}/>}</div>
  );
};

export default DeviceCredentialForm;
